import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../services/firebase/auth.service';
import { AESService } from 'src/app/APIservices/encryption/aes.service';
import { NavService } from '../services/nav.service';

@Injectable({
    providedIn: 'root'
})

export class SecureInnerPagesGuard implements CanActivate {
   items:any=[]
    constructor(private nav: NavService ,private enc:AESService,private authService: AuthService, private router: Router) {
        this.nav.items.subscribe(menuItems => {
            this.items=menuItems
        }) 
     }
    canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
       for(let key of this.items){
           
        if (this.router.url== key.path) {
             window.alert("You are not allowed to access this URL!");
           return false
           
             // this.router.navigate(['/dashboard/default'])
        }
        return true;
    }
}
}